<template>
  <div class="sales-header" >
    <div class="time df-c">
      <img
        src="@/assets/images/bigscreenSales/time.png"
        width="24px"
        height="24px"
      />
      <span>{{ nowTime }}</span>
    </div>
    <div class="title">{{ compname }}</div>
    <div class="week df-c">
      第
      <span class="week-num">{{ weeks }}</span
      >周
      <span class="m-l-16">{{ week }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesHeader',
  data () {
    return {
      timer: '', // 定义一个定时器
      nowTime: '',
      weeks: '',
      week: '',
      compname: '',
      logtime:'',
      requestUrl:'',
    }
  },
  components: {},
  watch: {},
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.compname =window.localStorage.getItem('bsmcompname')
    this.getTime()
  },
  methods: {
    getTime () {
      this.timer = setInterval(() => {

        let timeDate = new Date()
        if(this.logtime.length==0)
         {
           this.logtime=window.localStorage.getItem('bsmlogdate')
           this.logtime = this.logtime.replace(/-/g, '/');
           let tt=new Date(this.logtime);
           //console.log(this.logtime+"tt="+tt +' (timeDate<tt)='+(timeDate<tt))
           if(timeDate<tt)
             timeDate=tt;
        }
        

        let year = timeDate.getFullYear()
        let mounth = timeDate.getMonth() + 1
        let day = timeDate.getDate()
        let hours = timeDate.getHours()
        hours = hours >= 10 ? hours : '0' + hours
        let minutes = timeDate.getMinutes()
        minutes = minutes >= 10 ? minutes : '0' + minutes
        let seconds = timeDate.getSeconds()
        seconds = seconds >= 10 ? seconds : '0' + seconds
        // day = timeDate.getDay;
        let week = timeDate.getDay()
        let wks = Math.ceil((day + 6 - week) / 7)
        let weekArr = [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ]
        this.week = `${weekArr[week]}`

        wks = this.getYearWeek(timeDate)
        this.weeks = `${wks}`
        // alert("uuuu"+this.nowTime +`${weekArr[week]}`);
        this.nowTime = `${year}/${mounth}/${day} ${hours}:${minutes}:${seconds}`
        this.logtime=this.nowTime    
        if(hours=='07' && minutes==10 && seconds==15)    
        {
          window.localStorage.setItem('bsmlogdate', this.nowTime)
        }
      }, 1000)
    },
    beforeDestroy () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    // 计算本年的周数
    getYearWeek (endDate) {
      // 本年的第一天
      var beginDate = new Date(endDate.getFullYear(), 0, 1)
      // 星期从0-6,0代表星期天，6代表星期六
      var endWeek = endDate.getDay()
      if (endWeek === 0) endWeek = 7
      var beginWeek = beginDate.getDay()
      if (beginWeek === 0) beginWeek = 7
      // 计算两个日期的天数差
      var millisDiff = endDate.getTime() - beginDate.getTime()
      var dayDiff = Math.floor(
        (millisDiff + (beginWeek - endWeek) * (24 * 60 * 60 * 1000)) / 86400000
      )
      return Math.ceil(dayDiff / 7) + 1
    }
  },
  mounted () {
    this.$eventBus.$on('logtime', (times) => {
       console.log('times='+times)
    })
  },
  beforeDestroy () {
    this.$EventBus.$off('logtime')    
  },
}
// background-image: url("../../../assets/images/bigscreenSales/header.png");  
</script>

<style scoped lang="less">
.sales-header {
  height: 74px;
  background: linear-gradient(
    270deg,
    #060c16 0%,
    rgba(9, 28, 45, 0.9) 50.06%,
    #11182d 101.04%
  );
  background-image: url("http://47.107.138.238/img/header.png");  
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .time {
    position: absolute;
    top: 50%;
    left: 22px;
    transform: translateY(-50%);
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
    height: 24px;
    line-height: 26px;
    img {
      margin-right: 6px;
    }
  }
  .week {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 88px;
    height: 28px;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #ffffff;
    .week-num {
      margin: 0 6px;
      color: #80dbf8;
      font-weight: 700;
      font-style: normal;
      font-size: 24px;
    }
  }
  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-family: "YouSheBiaoTiHei";
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    letter-spacing: 0.03em;
    background: linear-gradient(180deg, #ffffff 37.41%, #b4cff2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/SalesHeader.vue